


























import {Component, Vue, Prop, Watch, Emit} from "vue-property-decorator";
import {translate} from "@/services/translation/translation";
import './_radio-group.less';
import $ from 'jquery';
import {goToTop} from "@/services/position/position";
import {string} from "prop-types";

@Component({})

export default class RadioGroup extends Vue {
    @Prop() model;
    @Prop() refresh;

    private data: any = {
        model: '',
        onlyIndex: 0
    };

    mounted(){
        goToTop('', this.model.componentSetting.id);
    }

    updated() {
        let self = this;
        $.each(this.model.componentSetting.items, function (index, item) {
            if (item.id == self.data.model && !item.isEnabled) {
                self.data.model = "";
            }
        });
        if(this.data.model != '' && (this.model.value_id == "" || this.model.value == "" ) ){
            this.changeComponentSettingModel(this.data.model);
        }

    }

    trans(key) {
        return translate(key);
    }

    get getItems() {
        return this.model.componentSetting.items;
    }

    @Watch("data.model", {immediate: true, deep: true})
    changeComponentSettingModel(newValue) {
        let componentValue: any = {};
        let self = this;
        if (newValue != '') {
            $.each(this.model.componentSetting.items, function (index, element) {
                if (element.id == newValue) {
                    componentValue.id = self.model.componentSetting.id;
                    componentValue.name = self.model.componentSetting.name;
                    componentValue.value = element.value;
                    componentValue.value_id = element.id;
                    componentValue.next_question = element.next_question;
                    componentValue.isEnableNext = self.model.isEnableNext;
                    if (typeof element.alternatenext != "undefined") {
                        componentValue.alternatenext = element.alternatenext;
                    }
                }
            });
        } else {
            componentValue.id = self.model.componentSetting.id;
            componentValue.name = self.model.componentSetting.name;
            componentValue.value = '';
            componentValue.value_id = '';
            componentValue.next_question = '';
            componentValue.isEnableNext = false;
        }

        this.onSelectedQuestionValue(componentValue);

    }

    resetComponentSettingModel() {
        let componentValue: any = {};
        let self = this;
        componentValue.id = self.model.componentSetting.id;
        componentValue.name = self.model.componentSetting.name;
        componentValue.value = '';
        componentValue.value_id = '';
        componentValue.next_question = '';
        componentValue.isEnableNext = self.model.isEnableNext;
        this.onResetQuestionValue(componentValue);
    }

    @Emit("selectedQuestionValue")
    onSelectedQuestionValue(value) {
    }

    @Emit("resetQuestionValue")
    onResetQuestionValue(value) {
    }

}

